import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AcornsIcon } from '@acorns/icons';
import { ModalActionTypes, ConfirmationModal } from '@acorns/web-components';
import { addIndex, map } from 'ramda';
import { getContext, branch, renderComponent, createSink, compose, withState, withContext } from 'recompose';
var mapIndex = addIndex(map);
var PromptV2PropTypes = {
  closeModal: PropTypes.func.isRequired,
  prompted: PropTypes.bool.isRequired,
  promptUser: PropTypes.func.isRequired,
  setCustomModal: PropTypes.func.isRequired
};

var PromptProvider = /*#__PURE__*/function (_PureComponent) {
  _inherits(PromptProvider, _PureComponent);

  var _super = _createSuper(PromptProvider);

  function PromptProvider(props) {
    var _this;

    _classCallCheck(this, PromptProvider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "pending", void 0);

    _defineProperty(_assertThisInitialized(_this), "customModal", null);

    _defineProperty(_assertThisInitialized(_this), "onAcknowledge", function (event) {
      var _this$pending;

      _this.setState({
        isOpen: false
      });

      (_this$pending = _this.pending) === null || _this$pending === void 0 ? void 0 : _this$pending.resolve(event);
      _this.pending = null;
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      return _this.setState({
        isOpen: false,
        prompted: false
      });
    });

    _this.pending = null;
    _this.state = {
      custom: undefined,
      isOpen: false,
      title: 'Oops!',
      image: /*#__PURE__*/React.createElement(AcornsIcon, {
        icon: AcornsIcon.Icon.Alert
      }),
      message: 'It looks like something went wrong.',
      actions: [{
        type: ModalActionTypes.primary,
        label: 'OK'
      }],
      prompted: false
    };
    _this.promptUser = _this.promptUser.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PromptProvider, [{
    key: "setCustomModal",
    value: function setCustomModal(customModal) {
      this.customModal = customModal;
    }
  }, {
    key: "promptUser",
    value: function promptUser(config) {
      var _config$image,
          _this2 = this;

      if (this.state.isOpen) {
        // Attempted to prompt user when prompt is already showing. This is a NO-OP
        return Promise.reject();
      }

      this.setState({
        actions: config.actions,
        buttonStyle: config.buttonStyle,
        custom: config.custom,
        eventFields: config.eventFields,
        image: (_config$image = config.image) !== null && _config$image !== void 0 ? _config$image : /*#__PURE__*/React.createElement(AcornsIcon, {
          icon: AcornsIcon.Icon.Alert
        }),
        isOpen: true,
        message: config.message,
        prompted: true,
        title: config.title
      });
      return new Promise(function (resolve, reject) {
        _this2.pending = {
          resolve: resolve,
          reject: reject
        };
      });
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      var closeModal = this.closeModal,
          promptUser = this.promptUser,
          setCustomModal = this.setCustomModal;
      var prompted = this.state.prompted;
      return {
        closeModal: closeModal,
        promptUser: promptUser,
        prompted: prompted,
        setCustomModal: setCustomModal
      };
    }
  }, {
    key: "render",
    value: function render() {
      var CustomModal = this.customModal;
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.children, this.state.custom && CustomModal ? /*#__PURE__*/React.createElement(CustomModal, _extends({}, this.state, this.state.custom, {
        actions: this.actions
      })) : /*#__PURE__*/React.createElement(ConfirmationModal, _extends({}, this.state, {
        actions: this.actions,
        onRequestClose: this.closeModal
      })));
    }
  }, {
    key: "actions",
    get: function get() {
      var _this3 = this;

      if (this.state.actions) {
        return mapIndex(function (action, index) {
          return _objectSpread(_objectSpread({}, action), {}, {
            handler: _this3.onAcknowledge.bind(_this3, _objectSpread({
              index: index
            }, action))
          });
        }, this.state.actions);
      } else {
        throw new Error('Prompt must receive "actions" config');
      }
    }
  }]);

  return PromptProvider;
}(PureComponent);

_defineProperty(PromptProvider, "childContextTypes", PromptV2PropTypes);

var ChangeAPIProptype = {
  api: PropTypes.number.isRequired,
  setApi: PropTypes.func.isRequired
};
export var API;

(function (API) {
  API[API["v1"] = 0] = "v1";
  API[API["v2"] = 1] = "v2";
})(API || (API = {}));

var ChooseApiVersion = function ChooseApiVersion(api) {
  return createSink(function (_ref) {
    var setApi = _ref.setApi;
    return setApi(api);
  });
};

var enhance = compose(withState('api', 'setApi', API.v1), withContext(ChangeAPIProptype, function (_ref2) {
  var api = _ref2.api,
      setApi = _ref2.setApi;
  return {
    api: api,
    setApi: setApi
  };
}));
var PromptProviderV2 = enhance(PromptProvider);
var withPromptV2 = compose(getContext(ChangeAPIProptype), branch(function (_ref3) {
  var api = _ref3.api;
  return api !== API.v2;
}, renderComponent(ChooseApiVersion(API.v2))), getContext(PromptV2PropTypes));
export { PromptProviderV2, withPromptV2 };